import Top from "@/components/Top";
import Client from "@/components/Client";
import Driver from "@/components/Driver";
import Map from "@/components/Map";
import Standby from "@/components/Standby";
import OutOfService from "@/components/OutOfService";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Top",
      component: Top,
    },
    {
      path: "/client",
      name: "Client",
      component: Client,
    },
    {
      path: "/driver",
      name: "Driver",
      component: Driver,
    },
    {
      path: "/map",
      name: "Map",
      component: Map,
    },
    {
      path: "/standby",
      name: "Standby",
      component: Standby,
    },
    {
      path: "/outOfService",
      name: "OutOfService",
      component: OutOfService,
    },
  ],
});
